exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".shopcar-detail-dialog .el-dialog__header{padding:16px 24px;text-align:center;border-bottom:1px solid #ebeef5}.shopcar-detail-dialog .el-dialog__title{font-size:20px;font-weight:600;color:#303133;letter-spacing:1px;line-height:28px}.shopcar-detail-dialog .el-dialog__headerbtn{top:18px;right:20px}.shopcar-detail-dialog .el-dialog__body{padding:16px 24px 10px;max-height:70vh;overflow-y:auto}.shopcar-detail-dialog .el-dialog__footer{text-align:right;padding:10px 24px 20px;border-top:1px solid #ebeef5}", ""]);

// exports
